/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-28 09:46:13
 * @LastEditors: hexy
 * @LastEditTime: 2024-01-09 10:36:23
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/consignment/QueryPage'
export const queryPage2 = '/icps/system/sign/dataCollection/consignment/QueryPageForSupplier'
export const queryPage3 = '/icps/system/sign/settlement/client/getClientAffirm'
export const Download = '/icps/system/sign/dataCollection/consignment/receiveexportList'
export const Download2 = '/icps/system/sign/dataCollection/consignment/dealExportList'
/*获取异常处理*/
export function getConsignmentIssue(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/getConsignmentIssue',
    method: 'post',
    data
  })
}
/*补录*/
export function additionalRecording(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/additionalRecording',
    method: 'post',
    data
  })
}
/*获取检测历史数据*/
export function getListByPid(data) {
  return request({
    url: '/icps/system/sign/intelligent/make/getListByPid',
    method: 'post',
    data
  })
}
/*获取检测历史数据*/
export function save1(data) {
  return request({
    url: '/icps/system/sign/intelligent/make/save',
    method: 'post',
    data
  })
}
/*获取检测结果*/
export function getDetail(data) {
  return request({
    url: '/icps/system/sign/intelligent/result/getDetail',
    method: 'post',
    data
  })
}
/**接受或者拒绝*/
export function AcceptOrRej(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/AcceptOrReject',
    method: 'post',
    data
  })
}
/**接受或者拒绝*/
export function clientupdateStatus(data) {
  return request({
    url: '/icps/system/sign/settlement/client/updateStatus',
    method: 'post',
    data
  })
}
/**
 * @Description: 获取供应计划列表
 * @Param: 
 * @Author: wangwangwang
 */
export function queryListBysupplierId(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplierPlanDetail/queryListBysupplierId',
    method: 'post',
    data
  })
}

/**
 * @Description: 修改计划提交
 * @Param: 
 * @Author: wangwangwang
 */
export function makeupdatePlan(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/updateDetailByPlan',
    method: 'post',
    data
  })
}
/**
 * @Description: 退货
 * @Param: 
 * @Author: wangwangwang
 */
 export function returnGoods(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/returnGoods',
    method: 'post',
    data
  })
}
/**
 * @Description: 提交审核功能
 * @Param: 
 * @Author: 刘小二
 */
 export function auditConsiment(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/auditConsiment',
    method: 'post',
    data
  })
}

/**
 * @Description: 取消审核
 * @Param: 
 * @Author: 刘小二
 */
 export function cancelAuditConsiment(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/cancelAuditConsiment',
    method: 'post',
    data
  })
}
/**
 * @Description: 冲销
 */
 export function backConsiment(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/backConsiment',
    method: 'post',
    data
  })
}
/**
 * @Description: 删除
 */
 export function deleteTask(params) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/deleteTask',
    method: 'get',
    params
  })
}
export function updateFactoryNumber(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/updateFactoryNumber',
    method: 'post',
    data
  })
}
// 获取甲供列表
export function queryProjectProvidedByPartyA(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringExtend/queryProjectProvidedByPartyA",
    method: "post",
    data,
  });
}
// 保存甲供工程
export function updateEngineering(data) {
  return request({
    url: "/icps/system/sign/dataCollection/consignment/updateEngineering",
    method: "post",
    data,
  });
}